import React, { useState, useEffect } from "react";
import UserHeader from "./UserHeader";
import { Link } from "react-router-dom";
import { getUserDashboardInformation } from "../../Utils/userFunctions";
import { getSurveyStatusName } from "../../Utils/commonFunctions";
import { Table, Modal } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";

function UserDashboard() {
  const [show, setShow] = useState(false);
  const [showApproval, setShowApproval] = useState(false);
  const [dashboardData, setDashboardData] = useState("");
  const [notificationList, setNotificationList] = useState("");
  const [draftsurveyapprovallist, setDraftsurveyapprovallist] = useState("");
  const [surveyApprovallist, setSurveyApprovallist] = useState("");
  const handleShow = () => {
    setShow(true);
    setShowApproval(false);
  };
  const handleClose = () => {
    setShow(false);
    setShowApproval(false);
  };

  const handleSurveyApprovalShow = () => {
    setShow(false);
    setShowApproval(true);
  };
  const handleSurveyApprovalClose = () => {
    setShowApproval(false);
    setShow(false);
  };
  useEffect(() => {
    async function fetchAPI1() {
      const response = await getUserDashboardInformation();
      if (response.status == "success") {
        setDashboardData(response.data);
        if (response.data.draft_survey_approval_list) {
          setDraftsurveyapprovallist(response.data.draft_survey_approval_list);
          setSurveyApprovallist(response.data.survey_approval_list);
        }

        if (response.data.notification_survey) {
          let optionItems = response.data.notification_survey.map((item, i) => (
            <div className="notifications-list-item" key={i}>
              <div className="notifications-item-text">
                <p>
                  <Link to={"/UserSurveyDetails/" + item.survey_id}>
                    {item.survey_name} is {getSurveyStatusName(item.status)}
                  </Link>
                </p>
              </div>
            </div>
          ));

          setNotificationList(optionItems);
        } else {
          setNotificationList("");
        }
      } else {
        toast.error(response.message, { autoClose: 1500 });
      }
    }
    fetchAPI1();
  }, []);

  return (
    <div>
      
      <UserHeader />
      <div className="container">
        <div className="row mt-3">
          <div className="col-md-12 col-sm-12 col-lg-8">
            <div className="row">
              <div className="col-md-11">
                <h6 className="dash_heading">Overview</h6>
                <div className="row">
                  <div className="col-md-6 col-sm-12 col-lg-6">
                    <div className="overview-card">
                      <Link to="/UserDevices">
                        <div className="overview-card-icon">
                          <img
                            height="60"
                            className="box-image"
                            src={require("../../Assets/Images/devices.png")}
                            alt="N/A"
                          />
                        </div>
                        <div className="overview-card-content">
                          <div className="title-value dash_box_title_value">
                            {dashboardData.device_count}
                          </div>
                          <div className="title-text">Number of Devices</div>
                        </div>
                      </Link>
                    </div>
                  </div>

                  <div className="col-md-6 col-sm-12 col-lg-6 ">
                    <div className="overview-card">
                      <Link to="/UserListSurveys">
                        <div className="overview-card-icon">
                          <img
                            height="60"
                            className="box-image"
                            src={require("../../Assets/Images/survey.png")}
                            alt="N/A"
                          />
                        </div>
                        <div className="overview-card-content">
                          <div className="title-value dash_box_title_value">
                            {dashboardData.survey_count}
                          </div>
                          <div className="title-text">Number of Surveys</div>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-12 col-sm-12 col-lg-4">
            <div className="row">
              <div className="col-md-12">
                <h6 className="dash_heading">Pending Action Items</h6>
                <div className="row">
                  <div className="col-md-6 col-sm-12 col-lg-6">
                    <div className="pending-card">
                      <div className="pending-card-content">
                        <Link
                          to="#"
                          onClick={() => {
                            handleShow();
                          }}
                        >
                          <div className="title-value text-center dash_box_title_value">
                            {dashboardData.draft_approval_count}
                          </div>
                          <div className="title-text text-center">
                            Draft Approval
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6 col-sm-12 col-lg-6">
                    <div className="pending-card">
                      <div className="pending-card-content">
                        <Link
                          to="#"
                          onClick={() => {
                            handleSurveyApprovalShow();
                          }}
                        >
                          <div className="title-value text-center dash_box_title_value">
                            {dashboardData.survey_approval_count}
                          </div>
                          <div className="title-text text-center">
                            Survey Approval
                          </div>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-md-12 col-sm-12 col-lg-8">
            <div className="row">
              <div className="col-md-11">
                <div
                  className="chart-card"
                  style={{ maxHeight: "270px", minHeight: "270px" }}
                >
                  <div className="row">
                    <div className="col-md-6">
                      <h2 className="text-justify">
                        FastPMCF
                        <sup className="font-size-13">
                          <sup>TM</sup>
                        </sup>
                        : Single platform to manage all your PMCF surveys
                      </h2>
                      <p className="text-justify font-size-14">
                        Review and approve surveys for multiple devices, view
                        responses in real-time, carry out analysis based on
                        geography, view the survey analysis report and much
                        more.
                      </p>
                    </div>
                    <div className="col-md-6">
                      <img
                        className="img-fluid img-responsive"
                        src={require("../../Assets/Images/demo.jpg")}
                        alt="N/A"
                      />
                      <p className="text-center text-dark h6 p-1">
                        Take the tour to do more
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-12 col-sm-12 col-lg-4">
            <div
              className="notifications-card"
              style={{ minHeight: "270px", maxHeight: "270px" }}
            >
              <h2>Notifications</h2>
              <div className="notification-list scrollbar-custom square thin">
                {notificationList}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showApproval}
        onHide={handleSurveyApprovalClose}
        animation={false}
      >
        <Modal.Header className="modal_custom_header text-center ">
          <h5 className="text-white p-0 m-0">Survey Approval</h5>
        </Modal.Header>
        <Modal.Body>
          <Table bordered size="sm">
            <tbody>
              {surveyApprovallist.length > 0 ? (
                surveyApprovallist.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <Link
                        to={
                          "/manufacturer/reports/analysis_report/" +
                          row.survey_id
                        }
                      >
                        {row.survey_name}
                      </Link>
                    </td>
                  </tr>
                ))
              ) : (
                <>
                  <tr>
                    <td>
                      {" "}
                      <div className="text-center">No records found</div>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>

      <Modal show={show} onHide={handleClose} animation={false}>
        <Modal.Header className="modal_custom_header text-center ">
          <h5 className="text-white p-0 m-0">Draft Survey Approval</h5>
        </Modal.Header>
        <Modal.Body>
          <Table bordered hover size="sm">
            <tbody>
              {draftsurveyapprovallist.length > 0 ? (
                draftsurveyapprovallist.map((row, index) => (
                  <tr key={index}>
                    <td>
                      <Link to={"/survey-form/preview/" + row.survey_id}>
                        {row.survey_name}
                      </Link>
                    </td>
                  </tr>
                ))
              ) : (
                <>
                  <tr>
                    <td>
                      <div className="text-center">No records found</div>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </Table>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default UserDashboard;
